import React from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import CartItems from './CartItems';
import CartAddOns from './CartAddOns';
import Totals from './Totals';
import Button from '../Elements/Button/Button';
import ErrorBoundary from '../../hocs/ErrorBoundary/ErrorBoundary';
import { translate, prefix } from '../../utils/locale';
import s from './Cart.scss';

const Cart = ({ checkout, closeCartHandler, setup }) => {
	const { items = [] } = checkout.selection;

	return (
		<div className={s.cart}>
			<div className={s.cart_title}>
				<span className={s.cart_title_text}>{ `${translate(setup, 'cart')} (${items.length})` }</span>
				<button className={s.cart_title_close} type="button" aria-label="Close cart" onClick={closeCartHandler}>
					<svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12">
						<g fill="none" stroke="#000" strokeWidth="2" transform="translate(1 1.455)">
							<polyline points="6.455 0 11 4.545 6.455 9.09" />
							<line x2="10" y1="4.545" y2="4.545" strokeLinecap="square" />
						</g>
					</svg>
				</button>
			</div>
			{
				items.length > 0 ? (
					<>
						<div className={s.cart_items}>
							<ErrorBoundary message="CartItems:" debugData={items}>
								<CartItems />
							</ErrorBoundary>
						</div>
						<ErrorBoundary message="Cart Add-ons:" debugData={items}>
							<CartAddOns setup={setup} items={items} />
						</ErrorBoundary>
						<div className={s.cart_totals}>
							<Totals setup={setup} selection={checkout.selection} cart />
						</div>
					</>
				) : (
					<div className={s.cart_items}>{ translate(setup, 'checkoutNoItems') }</div>
				)
			}
			<div className={s.cart_checkout}>
				<Button id="goToCheckout" text={translate(setup, 'goToCheckout')} type={checkout.klarnaLoaded ? 'a' : 'link'} location={prefix(setup, 'selection')} href={prefix(setup, 'selection')} />
			</div>
		</div>
	);
};

const mapState = ({ checkout, environment }) => {
	const { setup, header } = environment;
	return { checkout, setup, header };
};

export default hot(module)(connect(mapState)(Cart));
